import React, { useState, useEffect } from 'react';

import { AnnotationContext } from '../context/AnnotationContext';
import { useAnnotationContextController } from '../context/AnnotationContextController';

import AnnotationList from './AnnotationList';
import ImageLabeler from './ImageLabeler';

import { Icon } from 'semantic-ui-react';

import '../stylesheets/app.scss';


function App() {
  const annotationContext = useAnnotationContextController()
  const { annotations, setSelectedAnnotation, selectedImageIndex, setSelectedImageIndex } = annotationContext

  // const currentAnnotation = annotations[selectedImageIndex]

  // Tried extension #1
  const currentAnnotation = annotations.filter(annotation => annotation.testId === `${(selectedImageIndex + 1).toString().padStart(4, '0')}.jpg`)

  annotationContext.currentAnnotation = currentAnnotation


  console.log("copied current", currentAnnotation)
  // Need to set selectedAnnotation to null when the index is updated to avoid showing annotations for the previous image.
  const handlePrevClick = () => {
    if (selectedImageIndex > 0) {
      setSelectedAnnotation(null)
      setSelectedImageIndex(selectedImageIndex - 1)
    }
  };

  const handleNextClick = () => {
    if (selectedImageIndex <= 13) {
      setSelectedAnnotation(null)
      setSelectedImageIndex(selectedImageIndex + 1)
    }
  };

  // 1. Fecth save API
  // const saveAnnotations = (e) => {
  //   e.preventDefault();
  //   const annotationsJSON = JSON.stringify(annotationContext.annotations)
  //
  //   fetch('http://localhost:3001/save', {
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     body: annotationsJSON
  //   })
  //       .then(response => {
  //         if (!response.ok) {
  //           throw new Error('Error saving annotations data')
  //         }
  //         window.alert('Annotations saved successfully!')
  //       })
  //       .catch(error => {
  //         console.error('Error saving annotations data:', error)
  //       })
  // }

  // 2. Download from browser
  const saveAnnotations = (e) => {
    e.preventDefault();
    const annotationsJSON = JSON.stringify(annotationContext.annotations, null, 2);

    // Create a Blob object from the JSON string
    const blob = new Blob([annotationsJSON], { type: 'application/json' });

    // Create a URL for the blob
    const url = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement('a');
    link.href = url;
    link.download = 'annotations.json'; // Set the download attribute to specify the filename

    // Append the link element to the DOM
    document.body.appendChild(link);

    // Click the link to trigger the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);

    // Revoke the URL to free up memory
    URL.revokeObjectURL(url);
  };


  // Keyboard action
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.keyCode === 37 && selectedImageIndex > 0) {
        handlePrevClick()
      } else if (event.keyCode === 39 && selectedImageIndex < 13) {
        handleNextClick()
      }
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [selectedImageIndex])

  return (
      <AnnotationContext.Provider value={annotationContext}>
        <div className="app">
          <header>Multi Image Labeling</header>
          <div className='annotation-layout-container'>
            <div className="image-arrow-container">
              <ImageLabeler annotations={currentAnnotation ? currentAnnotation : []}/>
              <div className="arrow-buttons-container">
                <Icon
                    name="arrow circle left" size="large"
                    onClick={handlePrevClick}
                    disabled={selectedImageIndex === 0}
                />
                <Icon
                    name="arrow circle right" size="large"
                    onClick={handleNextClick}
                    disabled={selectedImageIndex === 13}
                />
              </div>
            </div>
            <AnnotationList />
            <Icon id="save_icon" name="save" size="large" color="blue"
                  onClick={saveAnnotations}/>
          </div>
        </div>
      </AnnotationContext.Provider>
  )
}

export default App
